<template>
  <mdb-container fluid id="about" class="overflow-hidden">
    <mdb-row class="pt-3 pb-3 mb-3 d-flex blue-header">
      <mdb-col class="col-12 text-left pl-4 pr-4">
        <img
          class="logo"
          src="../assets/img/csc-white.svg"
          width="140"
          height="49"
        />
        <a
          class="link light consult-position"
          target="_blank"
          href="https://www.csc.gov.au/Employers/Contact-us"
        >
          <img
            class="icon-arrow-help"
            src="../assets/icons/big-arrow-white-outline.svg"
          />
          <span>Need help? Contact us</span>
        </a>
      </mdb-col>
    </mdb-row>

    <mdb-row class="pt-4 pb-4">
      <mdb-col class="flex-grow-7 flex-snap text-left"></mdb-col>

      <mdb-col class="flex-grow-3 flex-snap align-self-center text-right">
        <WizardStep :step="1" />
      </mdb-col>
    </mdb-row>

    <mdb-row class="flex-row mb-lg-5" responsive>
      <ValidationObserver ref="observer" class="w-100">
        <div class="about-inset">
          <mdb-container fluid>
            <mdb-row class="text-left dots-left">
              <mdb-col class="col-12 p-0 pt-5 big-circle">
                <h2>
                  About your employee
                </h2>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col class="pl-5 pt-4 pb-0"></mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left" id="formFields">
              <mdb-col class="col-12 p-0 pb-4">
                <!-- Spacing above gradient -->
              </mdb-col>
              <mdb-col class="pl-5 pt-4 pb-md-4 dots-margin-adjust gradient">
                <mdb-container fluid>
                  <mdb-row>
                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <label for="employee-name">Employee name</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors, classes }"
                        >
                          <input
                            type="text"
                            id="employee-name"
                            class="form-control"
                            :class="classes"
                            v-model="employeeName"
                          />
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </mdb-col>

                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <mdb-tooltip
                          trigger="hover"
                          boundrySelector="#about-inset"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">
                            This should be the member's birthday
                            <br />
                            or date of exit
                          </span>
                          <span class="icon-info" slot="reference"></span>
                        </mdb-tooltip>

                        <label for="date-of-review">Date of review</label>
                        <ValidationProvider
                          rules="required|valid_date|no_awote_rate:@nextAwoteRate"
                          name="verifyReview"
                          v-slot="{ errors, classes }"
                        >
                          <cleave
                            v-model="reviewDate"
                            :options="formatOptions.date"
                            :raw="false"
                            name="date-of-review"
                            type="text"
                            id="date-of-review"
                            class="form-control"
                            :class="classes"
                            placeholder="DD / MM / YYYY"
                          ></cleave>
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <!-- <ValidationProvider name="lastAwoteRate">
                          <input
                            type="hidden"
                            name="last-awote-rate"
                            id="last-awote-rate"
                            :value="awoteLastPubDate"
                          />
                        </ValidationProvider> -->

                        <ValidationProvider name="nextAwoteRate">
                          <input
                            type="hidden"
                            name="next-awote-rate"
                            id="next-awote-rate"
                            :value="awoteNextExpectedPubDate"
                          />
                        </ValidationProvider>
                      </div>
                    </mdb-col>

                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <label for="review-type">Review type</label>
                        <ValidationProvider name="reviewType">
                          <input
                            type="hidden"
                            name="review-type"
                            id="review-type"
                            :value="selectedReviewType"
                          />
                        </ValidationProvider>
                        <br />
                        <mdb-btn-group class="multi-select-group">
                          <mdb-btn
                            class="multi-select"
                            value="BIRTHDAY"
                            @click.native="toggleReviewTypeBtn"
                            :active="reviewType_bday"
                            >Birthday</mdb-btn
                          >
                          <mdb-btn
                            class="multi-select"
                            value="EXIT"
                            @click.native="toggleReviewTypeBtn"
                            :active="reviewType_exit"
                            >Exit</mdb-btn
                          >
                        </mdb-btn-group>
                      </div>
                    </mdb-col>

                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <label for="member-number">AGS / Member number</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors, classes }"
                        >
                          <input
                            type="text"
                            name="member-number"
                            id="member-number"
                            class="form-control"
                            :class="classes"
                            v-model="memberNumber"
                          />
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </mdb-col>

                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <mdb-tooltip
                          trigger="hover"
                          boundrySelector="#about-inset"
                          :options="{ placement: 'top' }"
                        >
                          <span slot="tip">
                            This is what your employee's super salary would be
                            if the salary reduction rules didn’t apply - the sum
                            of their base salary and recognised allowances on
                            their date of review.
                          </span>
                          <span class="icon-info" slot="reference"></span>
                        </mdb-tooltip>

                        <label for="salary-at-review">
                          <!-- Employee -->
                          Salary as at date of review
                        </label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors, classes }"
                        >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" :class="classes">
                                $
                              </span>
                            </div>
                            <cleave
                              v-model="reviewSalary"
                              :options="formatOptions.salary"
                              name="salary-at-review"
                              type="text"
                              id="salary-at-review"
                              class="form-control"
                              :class="classes"
                              placeholder="Amount"
                            ></cleave>
                          </div>
                          <span class="warning">{{
                            reviewSalaryWarning()
                          }}</span>
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </mdb-col>

                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <label for="super-scheme">Super scheme</label>
                        <ValidationProvider name="superScheme">
                          <input
                            type="hidden"
                            name="super-scheme"
                            id="super-scheme"
                            :value="superScheme"
                          />
                        </ValidationProvider>
                        <br />
                        <mdb-btn-group class="multi-select-group">
                          <mdb-btn
                            class="multi-select"
                            value="CSS"
                            @click.native="toggleSuperSchemeBtn"
                            :active="superScheme_css"
                            >CSS</mdb-btn
                          >
                          <mdb-btn
                            class="multi-select"
                            value="PSS"
                            @click.native="toggleSuperSchemeBtn"
                            :active="superScheme_pss"
                            >PSS</mdb-btn
                          >
                          <mdb-btn
                            class="multi-select"
                            value="PSSAP"
                            @click.native="toggleSuperSchemeBtn"
                            :active="superScheme_pssap"
                            >PSSap</mdb-btn
                          >
                        </mdb-btn-group>
                      </div>
                    </mdb-col>
                  </mdb-row>

                  <mdb-row>
                    <mdb-col
                      class="col-12 col-lg-6 col-xl-4 p-0 pr-5 pt-3 pb-3"
                    >
                      <div class="form-group">
                        <label for="date-of-birth">Date of Birth</label>
                        <ValidationProvider
                          rules="required|valid_date|birthday_review:@verifyReview,@reviewType|date_order:@verifyReview"
                          v-slot="{ errors, classes }"
                        >
                          <cleave
                            v-model="birthDate"
                            :options="formatOptions.date"
                            :raw="false"
                            name="date-of-birth"
                            type="text"
                            id="date-of-birth"
                            class="form-control"
                            :class="classes"
                            placeholder="DD / MM / YYYY"
                          ></cleave>
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </mdb-col>
                  </mdb-row>
                </mdb-container>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col class="pl-5 pt-5 pb-4">
                &nbsp;
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left">
              <mdb-col class="col-12 col-md-5 pt-2 pb-2 pl-5 small-circle">
                <p>
                  <a
                    class="underln"
                    href="javascript:;"
                    @click="showResetFields = true"
                  >
                    Reset employee fields
                  </a>
                </p>
              </mdb-col>

              <mdb-col
                class="col-12 pt-3 pb-3 pt-md-0 pb-md-0 col-md-7 text-right csc-btns-btm"
              >
                <router-link
                  to="/"
                  class="rounded btn btn-outline-primary ripple-parent"
                >
                  Cancel
                </router-link>
                <mdb-btn
                  class="rounded btn btn-primary"
                  @click.native="validateInputs"
                >
                  Next
                  <i class="fas icon-arrow"></i>
                </mdb-btn>
              </mdb-col>
            </mdb-row>
          </mdb-container>

          <mdb-modal
            :show="showNoRateModal"
            @close="showNoRateModal = false"
            centered
          >
            <mdb-modal-body class="text-left">
              A new rate is due to be applied on
              <b>{{ awoteNextExpectedUpdateText }}.</b><br /><br />
              As such, any calculation done on or before this date with the
              review date supplied, will be <b>incorrect.</b> <br /><br />
              Please return to the calculator on
              <b>{{ dayAfterUpdateText() }}</b> to perform this calculation, and
              receive the correct results.
            </mdb-modal-body>
            <mdb-modal-footer>
              <mdb-btn
                class="rounded"
                color="primary"
                @click.native="showNoRateModal = false"
                >Close</mdb-btn
              >
            </mdb-modal-footer>
          </mdb-modal>

          <mdb-modal
            :show="showResetFields"
            @close="showResetFields = false"
            centered
          >
            <mdb-modal-header>
              <mdb-modal-title>Reset Fields?</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body class="text-left">
              This action will remove any data you have entered.
            </mdb-modal-body>
            <mdb-modal-footer>
              <mdb-btn
                class="rounded"
                color="outline-primary"
                @click.native="showResetFields = false"
                >Cancel</mdb-btn
              >
              <mdb-btn
                class="rounded"
                color="primary"
                @click.native="resetEmployeeFields"
                >Reset</mdb-btn
              >
            </mdb-modal-footer>
          </mdb-modal>
        </div>
      </ValidationObserver>
    </mdb-row>

    <mdb-row class="no-gutters">
      <mdb-col>
        <Footer />
        <div id="feedback">
          <a
            href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=SQ6N45&type=AHC"
            target="_blank"
          >
            Feedback
          </a>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<style lang="scss">
@import "~@/scss/about.scss";
</style>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbBtnGroup,
  mdbTooltip,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

import { mapGetters, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import Cleave from "vue-cleave-component";
import WizardStep from "@/components/WizardStep.vue";
import Footer from "@/components/Footer.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend
} from "vee-validate";
import { required } from "vee-validate/dist/rules";

configure({
  classes: {
    invalid: "is-invalid"
  }
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("valid_date", dateVal => {
  if (dateVal !== null && dateVal.length === 10) {
    let now = new Date();
    let maxNum = parseInt("" + (now.getFullYear() + 3) + "1231");
    let dateNum = parseInt(
      dateVal
        .split("/")
        .reverse()
        .join("")
    );
    if (dateNum >= 19000101 && dateNum <= maxNum) {
      return true;
    }
  }

  return "This date is invalid";
});

extend("birthday_review", {
  params: ["reviewDate", "reviewType"],
  validate(birthDate, { reviewDate, reviewType }) {
    if (reviewType === "BIRTHDAY") {
      if (
        birthDate === null ||
        reviewDate === null ||
        birthDate.length < 10 ||
        reviewDate.length < 10
      ) {
        return true;
      }
      let birthdayArr = birthDate.split("/");
      let reviewArr = reviewDate.split("/");
      if (
        (parseInt(birthdayArr[0]) === 29 && parseInt(birthdayArr[1]) === 2) ||
        (parseInt(birthdayArr[0]) === parseInt(reviewArr[0]) &&
          parseInt(birthdayArr[1]) === parseInt(reviewArr[1]))
      ) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  },
  message: "Birthday and review dates don't relate. Please check and adjust"
});

extend("date_order", {
  params: ["reviewDate"],
  validate(birthDate, { reviewDate }) {
    if (
      birthDate === null ||
      reviewDate === null ||
      birthDate.length < 10 ||
      reviewDate.length < 10
    ) {
      return true;
    }
    var birthdateNum = parseInt(
      birthDate
        .split("/")
        .reverse()
        .join("")
    );
    let reviewdateNum = parseInt(
      reviewDate
        .split("/")
        .reverse()
        .join("")
    );
    // Add 16 years to birthdate
    birthdateNum += 160000;

    if (reviewdateNum < birthdateNum) {
      return false;
    } else {
      return true;
    }
  },
  message: "Review date / birth dates are invalid. Please check and adjust"
});

extend("no_awote_rate", {
  params: ["nextAwoteRate"],
  validate(dateVal, { nextAwoteRate }) {
    if (dateVal !== null && dateVal.length === 10) {
      // let now = new Date();
      // let nowNum = parseInt(
      //   "" +
      //     now.getFullYear() +
      //     ("0" + (now.getMonth() + 1)).slice(-2) +
      //     ("0" + now.getDate()).slice(-2)
      // );

      let dateNum = parseInt(
        dateVal
          .split("/")
          .reverse()
          .join("")
      );
      if (dateNum >= parseInt(nextAwoteRate)) {
        // || nowNum >= parseInt(nextAwoteRate)
        return false;
      }
    }
    return true;
  },
  message: "No AWOTE rate available for this date"
});

//  Use : |pssap_inception:@superScheme
// extend("pssap_inception", {
//   params: ["superScheme"],
//   validate(dateVal, { superScheme }) {
//     if (superScheme === "PSSAP" && dateVal !== null && dateVal.length === 10) {
//       let dateNum = parseInt(
//         dateVal
//           .split("/")
//           .reverse()
//           .join("")
//       );
//       if (dateNum < 20050701) {
//         return false;
//       }
//     }
//     return true;
//   },
//   message: "The current review date is prior to 1 July 2005 - please review"
// });

export default {
  name: "About",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbBtnGroup,
    mdbTooltip,

    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,

    Cleave,
    ValidationProvider,
    ValidationObserver,
    WizardStep,
    Footer
  },

  computed: {
    reviewType: {
      get() {
        return this.reviewType;
      },
      set(value) {
        this.$store.commit("updateReviewType", value);
      }
    },

    superScheme: {
      get() {
        return this.superScheme;
      },
      set(value) {
        this.$store.commit("updateSuperScheme", value);
      }
    },

    ...mapFields([
      "employeeName",
      "reviewDate",
      "memberNumber",
      "reviewSalary",
      "birthDate"
    ]),
    ...mapState(["reviewType", "superScheme"]),
    ...mapGetters([
      "reductionCount",
      "awoteLastPubDate",
      "awoteNextExpectedPubDate",
      "awoteNextExpectedUpdateText",
      "formatOptions",
      "Enum"
    ])
  },

  watch: {
    reviewDate: function() {
      if (
        this.reviewDate !== null &&
        this.reviewDate.length === 10 &&
        this.dateToNum(this.reviewDate) >= this.awoteNextExpectedPubDate
      ) {
        this.showNoRateModal = true;
      } else {
        this.showNoRateModal = false;
      }
    }
  },

  methods: {
    setButtonDefaults() {
      if (this.reviewType === null || this.reviewType.length < 1) {
        this.toggleReviewType(this.Enum.reviewType.BIRTHDAY);
      } else {
        this.toggleReviewType(this.reviewType);
      }

      if (this.superScheme === null || this.superScheme.length < 1) {
        this.toggleSuperScheme(this.Enum.superScheme.PSS);
      } else {
        this.toggleSuperScheme(this.superScheme);
      }
    },

    reviewSalaryWarning: function() {
      if (this.reviewSalary > 10000000) {
        return "Please ensure the amount entered is $10M or less";
      } else if (this.reviewSalary > 1000000) {
        return "Salary in excess of $1 Million, proceed with caution";
      } else {
        return "";
      }
    },

    toggleReviewType(rType) {
      this.reviewType_bday = rType === this.Enum.reviewType.BIRTHDAY;
      this.reviewType_exit = rType === this.Enum.reviewType.EXIT;
      this.selectedReviewType = rType;
      this.$store.commit("updateReviewType", rType);
    },

    toggleSuperScheme(sScheme) {
      this.superScheme_css = sScheme === this.Enum.superScheme.CSS;
      this.superScheme_pss = sScheme === this.Enum.superScheme.PSS;
      this.superScheme_pssap = sScheme === this.Enum.superScheme.PSSAP;
      this.$store.commit("updateSuperScheme", sScheme);
      this.$store.commit("nullButtonFields", sScheme);
    },

    toggleReviewTypeBtn(e) {
      this.toggleReviewType(e.target.value);
    },

    toggleSuperSchemeBtn(e) {
      this.toggleSuperScheme(e.target.value);
    },

    dateToNum: dateVal => {
      return dateVal === null
        ? ""
        : parseInt(
            dateVal
              .split("/")
              .reverse()
              .join("")
          );
    },

    dayAfterUpdateText() {
      if (
        this.awoteNextExpectedPubDate !== undefined &&
        ("" + this.awoteNextExpectedPubDate).length === 8
      ) {
        let nextUpd = "" + this.awoteNextExpectedPubDate;
        var tomorrow = new Date(
          nextUpd.substring(0, 4) +
            "-" +
            nextUpd.substring(4, 6) +
            "-" +
            nextUpd.substring(6, 8)
        );
        tomorrow.setDate(tomorrow.getDate() + 1);
        let month = tomorrow.toLocaleString("en-GB", { month: "long" });
        return tomorrow.getDate() + " " + month + " " + tomorrow.getFullYear();
      }
    },

    properCase: value => {
      return value === null
        ? ""
        : value.toLowerCase().replace(/^(.)|\s(.)|'(.)|-(.)/g, function($u) {
            return $u.toUpperCase();
          });
    },

    fixEmployeeNameCase() {
      this.$store.commit(
        "updateEmployeeName",
        this.properCase(this.employeeName)
      );
    },

    validateInputs() {
      const scrollTo = scroller();
      this.errors = [];
      this.fixEmployeeNameCase();

      this.$refs.observer.validate().then(success => {
        if (!success) {
          scrollTo("#formFields");
          this.reSubmit = true;
          window.resizeIframe();
        } else {
          this.$router.push({ name: "Details" });
        }
      });
    },

    resetEmployeeFields() {
      this.$store.commit("resetReductions");
      this.$store.commit("resetEmployeeFields");
      this.setButtonDefaults();
      this.$refs.observer.reset();
      this.showResetFields = false;

      const scrollTo = scroller();
      scrollTo("#formFields");
      window.resizeIframe();
    }
  },

  mounted() {
    this.setButtonDefaults();
    window.triggerResize();
  },

  data() {
    return {
      showNoRateModal: false,
      showResetFields: false,
      errors: [],
      reSubmit: false,
      selectedReviewType: null,
      reviewType_bday: false,
      reviewType_exit: false,
      superScheme_css: false,
      superScheme_pss: false,
      superScheme_pssap: false
    };
  }
};
</script>
